<template>

</template>

<script>
    export default {
        name: "vertical"
    }
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/characteristic/vertical.vue